// extracted by mini-css-extract-plugin
export default {"tab":"SecondaryTab-module__tab__mcROi","disabled":"SecondaryTab-module__disabled__XAOHI","active":"SecondaryTab-module__active__1Qk4P","icon":"SecondaryTab-module__icon__2-akD"};